/**
 * Smooth scrolling utility that coordinates seamlessly with Lenis
 */

let isScrollLocked = false;
let unlockTimeout: NodeJS.Timeout | null = null;

export const scrollToSection = (sectionId: string, offset = -75): void => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('close-fullscreen-card'));
  }

  // Lock scroll-spy updates temporarily during programmatic glide
  isScrollLocked = true;
  if (unlockTimeout) clearTimeout(unlockTimeout);
  unlockTimeout = setTimeout(() => {
    isScrollLocked = false;
  }, 1000);

  const lenis = window.lenis;

  if (sectionId === 'hero' || sectionId === 'top') {
    if (lenis) {
      lenis.scrollTo(0, { duration: 1.1 });
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    return;
  }

  const element = document.getElementById(sectionId);
  if (element) {
    if (lenis) {
      lenis.scrollTo(element, { offset, duration: 1.1 });
    } else {
      const y = element.getBoundingClientRect().top + window.pageYOffset + offset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  }
};

export const isProgrammaticScrollActive = (): boolean => isScrollLocked;
